<template>
    <div class="container">
        <div class="content">
            <div v-html="footerHtmlText"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, defineProps, onMounted } from 'vue';
const footerHtmlText = ref('')
const props = defineProps<{
    itemData: {
        htmlText: string
    }
}>()
onMounted(() => {
    footerHtmlText.value = props.itemData.htmlText
})
</script>
<style scoped>
.container {
    padding: 10px 15px 50px;
    line-height: 20px;
    font-size: 11px;
}


.ql-align-center {
    text-align: center !important;
}

.ql-align-center span {
    display: inline-block;
    width: 100%;
}


.ql-align-right {
    text-align: right !important;
}

.ql-align-right span {
    display: inline-block;
    width: 100%;
}

.ql-align-left {
    text-align: left !important;
}

.ql-align-left span {
    display: inline-block;
    width: 100%;
}
</style>